import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import { RouteParameters } from '../../../constants'
import { Director } from '../../Director'
import { Home as Index } from '../../Home'
import { Providers } from '../Providers'
import { CountrySpecificRoutes } from './CountrySpecificRoutes'
import { AuthRoutes } from './AuthRoutes'

const Router = () => (
  <BrowserRouter>
    <Providers>
      <Routes>
        <Route element={<Index />} path="/" />
        <Route element={<Director />} path="/r" />
        <Route element={<AuthRoutes />} path="/auth/*" />
        <Route element={<CountrySpecificRoutes />} path={`:${RouteParameters.COUNTRY}/*`} />
        <Route element={<NotFound />} path="/*" />
      </Routes>
    </Providers>
  </BrowserRouter>
)

export { Router }
